import request from './index'

class students{ //优秀作文列表
    static studentsList(params){
        return request('get','/student/list',params,'no')
    }
    static score(params){
        return request('get','/word/score/list',params,'no')
    }
    static school(params){
        return request('get','/school/list',params,'no')
    }
}
export default students